import {
  useTrackFeature,
  useTrackFeatureInViewImpression,
} from '@aboutyou/tracking';

export const useTrackCouponWalletEntryPoint = () => {
  const featureTrackName = 'coupon_entrypoint';
  const trackFeature = useTrackFeature();
  const {ref: featureImpressionRef} =
    useTrackFeatureInViewImpression<HTMLButtonElement>({
      name: featureTrackName,
    });

  const trackFeatureClick = () => {
    trackFeature({
      eventType: 'click',
      name: featureTrackName,
    });
  };

  return {
    trackFeatureClick,
    featureImpressionRef,
  };
};
